module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": _vm.toptype
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shenbaoA animated fadeInUp"
  }, [_c('div', {
    staticStyle: {
      "border": "2px solid #eee",
      "padding": "30px 10px"
    }
  }, [_c('div', {
    staticClass: "box1_header ",
    staticStyle: {
      "margin-bottom": "20px",
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "box1_header_shu"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_header_text"
  }, [_vm._v(_vm._s(_vm.detail.title ? _vm.detail.title : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start align-start"
  }, [_c('div', {}, [_c('el-image', {
    staticStyle: {
      "width": "300px",
      "height": "300px",
      "border": "1px solid #eee"
    },
    attrs: {
      "src": _vm._f("addurl")(_vm.detail.image),
      "fit": "cover"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "680px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('div', {
    staticClass: "onetop"
  }, [_c('div', {
    staticClass: "onetitle"
  }, [_vm._v("房间号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detail.number))])]), _vm._v(" "), _c('div', {
    staticClass: "onetop"
  }, [_c('div', {
    staticClass: "onetitle"
  }, [_vm._v("位置：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detail.position)), _c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("楼")])])]), _vm._v(" "), _c('div', {
    staticClass: "onetop"
  }, [_c('div', {
    staticClass: "onetitle"
  }, [_vm._v("工位数：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detail.work))])]), _vm._v(" "), _c('div', {
    staticClass: "onetop"
  }, [_c('div', {
    staticClass: "onetitle"
  }, [_vm._v("面积：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detail.area)), _c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("㎡")])])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "2px solid #eee",
      "margin-top": "20px",
      "border-top": "none"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sd_content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })])])]), _vm._v(" "), (_vm.detail) ? _c('div', {
    staticClass: "new_bot flex justify-center align-center pointer",
    on: {
      "click": _vm.shownow
    }
  }, [_c('div', {
    staticClass: "bot_text"
  }, [_vm._v(_vm._s(_vm.config.zulin_detail ? _vm.config.zulin_detail : ''))]), _vm._v(" "), _c('div', {
    staticClass: "bot_btn"
  }, [_vm._v("立即获取")])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "咨询",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "name", $$v)
      },
      expression: "cominfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.phone),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "phone", $$v)
      },
      expression: "cominfo.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "咨询内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入咨询内容",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.content),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "content", $$v)
      },
      expression: "cominfo.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center align-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.nowdisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.tosub
    }
  }, [_vm._v("提 交")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "60px",
      "width": "100%",
      "background": "#eee"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "120px",
      "background": "#fff",
      "height": "100%",
      "font-size": "18px",
      "text-align": "center",
      "line-height": "60px",
      "border-top": "2px solid #0070c0"
    }
  }, [_vm._v("详细介绍")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dff83d9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tenancydetail.vue
// module id = 422
// module chunks = 1